module.exports = __webpack_public_path__ + "fonts/Graphik-Black.d8660897.ttf";